/**
 * change by Jession on 2018/04/011
 * 收货确认 -- list
 */

import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, InputNumber, message, Table} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {
    /*fetchList, */
    fetchListSingle,
    inputStorage,
    inputStorages,
    fetchSubStoreList,
    syncDelivery
} from '../../service/receiving';
import {fetchChannelList} from '../../service/home';
import {getGouXiaoUnitList} from "../../service/traceOrder";

class ReceivingList extends Reflux.Component {
    constructor(props) {
        super(props);
        let channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        let userInfo = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.state = {
            opts: ['收货入库'],
            showHideBtnIndex: '',
            key: 0,
            selectedRowKeys: [],
            selectedRows: [],
            rows: [],
            total: 1,
            searchObj: {
                transportOrder: '', // 出库单
                orderNumber: '',  // 订单编号
                itemNum: '',  // 物料编号
                itemDesc: '', // 物料名称/描述
                salesUnitName: '',  // 购货单位
                salesUnitId: '',  // 购货单位ID
                startDate: '', // 开始日期
                endDate: '',  // 结束日期
                inportStatus: '1',  // 发货状态（0:未发，1:已发货未收货，2:已发货已收货）
                // inportStatus: 0,  // 入库状态（0:未入库，1:已入库）
                // channel: '', // 渠道ID
                s: 10,
                p: 1,
                salesChannelCode: ''
            },
            categoryData: [],
            channel_type: [], /* 渠道类型 */
            channel_list: [],
            visible: false,
            isAddStore: 'Y',  // 是否添加子库存
            substorageid: '',  // 子库存ID
            transportOrderId: '', // 单选的列表出库单号
            scInventory: [], // 子库存信息
            getGdList: [], //购货单位列表
            channelCode: channelData.split('|')[1] || '', // 当前渠道ID
            thirdId: userInfo.thirdId || userInfo.fatherThirdId, // 第三方标识(ERP) id
            showInStorage: true, // 是否显示入库按钮
            loading: true,
            confirmLoading: false,
            syncVisible: false,
            syncConfirmLoading: false,
            syncDelivery: ''
        }
        ;
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);

        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.isAddStore = this.isAddStore.bind(this);
        this.handleChange = this.handleChange.bind(this);
    };

    /*选择列表*/
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeys, selectedRows});
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        // console.log(name);
        if (name === 'confimDate') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from + ' 00:00:00',
                    endDate: value.end + ' 23:59:59'
                }
            })
            // } else if (name == 'salesUnitName') {
            //   console.log(value);
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                transportOrder: '', // 出库单
                orderNumber: '',  // 订单编号
                itemNum: '',  // 物料编号
                itemDesc: '', // 物料名称/描述
                salesUnitName: '',  // 购货单位
                salesUnitId: '',  // 购货单位ID
                startDate: '', // 开始日期
                endDate: '',  // 结束日期
                inportStatus: '1',  // 发货状态（0:未发货，1:已发货未收货，2:已发货已收货）
                channel: '', // 渠道ID
                // inportStatus: 0,  // 入库状态（0:未入库，1:已入库）
                p: 1,
                s: 10,
                salesChannelCode: ''
            },
            selectedRowKeys: [],
            selectedRows: [],
            channel_list: [], loading: true
        }, () => {
            self.initData();
        })
    };

    /* 筛选确认（查询） */
    advanceSubmit(form) {
        const self = this;
        let sObj = this.state.searchObj;
        let isShow = sObj.inportStatus == '1' ? true : false;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, showInStorage: isShow, loading: true}, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        this.setState({showInStorage: true});
        let obj = this.state.searchObj;
        fetchListSingle(obj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows: result.data,
                    total: result.total,
                    loading: false
                });
            } else {
                openNotice('error', '获取列表失败', (result && result.message) ? result.message : '');
                this.setState({loading: false});
            }
        });
    }

    /* 获取渠道 */
    getChannelList() {
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                // var arr = new Array();
                // var arr = [{text: '全部', value: ''}];
                var arr = [];

                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                this.setState({channel_list: arr});
            }
        });
    }

    /* 获取子库存 */
    getScInventory() {
        fetchSubStoreList({
            removeFlag: 0,
            s: 1000,
            p: 1,
        }).then(res => {
            // console.log(res);
            if (res.status && res.code == 200) {
                this.setState({scInventory: res.data});
            } else {
                openNotice('error', '获取列表失败', (res && res.message) ? res.message : '');
            }
        });
    }

    /* 获取购货单位 */
    getGdList() {
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => {
            if (res.status && res.code == 200) {
                const data = res.data || [];
                let arr = [
                    {
                        text: '全部',
                        value: '0'
                    }
                ];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.setState({getGdList: arr})
            } else {
                openNotice('error', '获取列表失败', (res && res.message) ? res.message : '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        const self = this;
        this.initData();
        this.getScInventory();
        this.getGdList();
        this.getChannelList();
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                // let arr = [
                //     {
                //         text: '全部',
                //         value: ''
                //     }
                // ];
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    addRecord(data) {  // 入库操作
        // console.log(this.state.selectedRowKeys);
        // console.log(this.state);
        // return
        let _id = '';
        if (data.transportOrder) {
            _id = data.transportOrder;
        } else {
            _id = '';
        }
        // debugger
        // console.log(data.record)
        // this.expandedRowRender(data.record,0);
        this.setState({visible: true, transportOrderId: _id, showInStorage: false});
    }

    /* 入库提交 */
    handleOk = () => {
        // console.log(this.state);
        this.setState({confirmLoading: true, showInStorage: false});
        let _state = this.state
            , _param = {}
            , _func = 'inputStorage'
        ;
        if (_state.isAddStore == 'Y' && !_state.substorageid) {
            message.warning('请选择子库存');
            this.setState({confirmLoading: false});
            return;
        }
        if (_state.transportOrderId) { // 单选入库提交
            _param = {
                transportOrder: _state.transportOrderId,
                substorageid: _state.substorageid,
                isAddStore: _state.isAddStore
            };
            inputStorages(_param).then(res => {
                if (res.status && res.code == 200) {
                    message.success('入库成功');
                    this.setState({substorageid: '', isAddStore: 'Y'});
                    this.initData();
                } else {
                    this.setState({showInStorage: true});
                    openNotice('error', '入库失败', (res && res.message) ? res.message : '');
                }
            });
        } else {  // 批量入库提交
            _param = [];
            this.state.selectedRows.forEach((item, index) => {
                /*return {
                  id: x.id,
                  substorageid: _state.substorageid,
                  isAddStore: _state.isAddStore
                };*/
                item.lineVoList.forEach((d, i) => {
                    _param.push({
                        id: d.id,
                        substorageid: _state.substorageid,
                        isAddStore: _state.isAddStore
                    })
                });
            });

            inputStorage(_param).then(res => {
                if (res.status && res.code == 200) {
                    message.success('入库成功');
                    this.setState({substorageid: '', isAddStore: 'Y'});
                    this.initData();
                } else {
                    this.setState({showInStorage: true});
                    openNotice('error', '入库失败', (res && res.message) ? res.message : '');
                }
            });
        }
        this.setState({visible: false, confirmLoading: false});
        //console.log(_param);
        // let x = eval(_func)
        // return;
    }

    /* 取消入库 */
    handleCancel = () => {
        this.setState({visible: false, substorageid: '', isAddStore: 'Y', confirmLoading: false, showInStorage: true});
    }

    isAddStore = (e) => { // 选择是否添加子库存（入库）
        console.log('radio checked', e.target.value);
        this.setState({
            isAddStore: e.target.value
        });
    }

    // 选择子库存（入库）
    handleChange(value) {
        // console.log('selected ' + value);
        this.setState({substorageid: value});
        // window.sessionStorage.setItem('cur_channel', value);
    }

    //同步
    sync = () => {
        this.setState({syncVisible: true, syncDelivery: '', syncConfirmLoading: false});
    }

    syncHandleOk = () => {
        if (this.state.syncDelivery == null || this.state.syncDelivery == '') {
            openNotice('error', '请输入出库单号');
            return;
        }
        this.setState({syncConfirmLoading: true});
        syncDelivery(this.state.syncDelivery).then(result => {
            if (result.code == 200) {
                this.setState({syncConfirmLoading: false, syncVisible: false});
                openNotice('success', '同步成功', '');
                this.initData();
            } else {
                this.setState({syncConfirmLoading: false});
                openNotice('error', result.message, '');
            }
        });
    }

    syncHandleCancel = () => {
        this.setState({syncVisible: false});
    }

    syncChange = (value) => {
        this.setState({syncDelivery: value});
    }


    /* 子库存Select选择项 */
    inventoryOption(item, index) {
        // console.log(item);
        return <Select.Option key={'s_' + index} value={String(item.id)}>{item.subStoreName}</Select.Option>;
    }

    // /* 搜索出库单号 */
    // selectTransportOrder(transportOrder) {
    //   console.log(transportOrder);
    //   this.setState({
    //     searchObj: {
    //       ...this.state.searchObj,
    //       transportOrder
    //     }
    //   }, () => {
    //     this.initData();
    //   });
    // }

    // onExpandedRowsChange (expandedRows) {
    //     console.log(expandedRows);
    //     debugger
    //   }
    //   onExpanded (expanded) {
    //     console.log(expandedRows);
    //     debugger
    //   }
    expandedRowRender = (record, index) => {
        // debugger
        const columns = [
            {title: '订单编号', dataIndex: 'orderNumber', key: 'orderNumber'},
            {title: '物料编号', dataIndex: 'itemNum', key: 'itemNum'},
            {title: '物料名称', dataIndex: 'itemDesc', key: 'itemDesc'},
            {title: '单位', dataIndex: 'unit', key: 'unit'},
            {title: '订购数量', dataIndex: 'orderSum', key: 'orderSum'},
            // { title: '发运数量', dataIndex: 'upgradeNum', key: 'upgradeNum' },
            {title: '已发货数量', dataIndex: 'quantity', key: 'quantity'},
            {title: '未接收数量', dataIndex: 'unquantity', key: 'unquantity'}
        ];
        const self = this;

        let data = record.lineVoList.map((d, i) => {
            return {
                ...d,
                key: i
            }
        });
        return (
            <div>
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                />
                <Button
                    size={'small'}
                    onClick={self.addRecord.bind(self, {transportOrder: record.transportOrder, record: record})}
                    style={{display: record.inportStatus == 2 ? 'none' : 'block'}}
                    //style={{display: this.state.showInStorage == true ? 'block' : 'none'}}
                    type="primary"
                >入库</Button>
            </div>
        );
    };

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            total,
            channel_type,
            searchObj,
            selectedRowKeys,
            selectedRows,
            showHideBtnIndex,
            visible,
            channel_list,
            loading,
            confirmLoading,
            syncVisible,
            syncConfirmLoading
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'transportOrder',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.transportOrder
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'itemNum',
                    label: '物料编号',
                    text: '输入物料编号',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'itemDesc',
                    label: '物料名称',
                    text: '输入物料名称',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '选择状态',
                    options: this.state.getGdList,
                    multiple: false,
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.salesUnitName || ''
                },
                {
                    name: 'confimDate',//startCreatedDate, endCreatedDate
                    label: '发货日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startDate || '',
                        end: searchObj.endDate || ''
                    }
                },
                {
                    name: 'inportStatus',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: '1', text: '未收货'},
                        {value: '2', text: '已收货'},
                        // { value: '0', text: '未发货' }
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.inportStatus || '未收货'
                },
                // {
                //   name: 'salesChannelCode',
                //   label: '渠道',
                //   // text: window.sessionStorage.getItem('cur_channel').split('|')[0] || '',
                //   // text: window.sessionStorage.getItem('cur_channel').split('|')[0] || '',
                //   type: 'default',
                //   defaultValue: searchObj.salesChannelCode,
                //   // disabled: true,
                // },
                {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.salesChannelCode
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam,
            expandedRows: []
        };

        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            expandedRowRender: this.expandedRowRender,
            columns: [
                {
                    title: '出库单号',
                    dataIndex: 'transportOrder'/*,
          render: (text, record, index) => {
            return <a href="javascript:void(0)" onClick={this.selectTransportOrder.bind(this, text)}>{text}</a>
          }*/
                },
                // {
                //     title: '渠道',
                //     dataIndex: 'salesChannelCode'
                // },
                {
                    title: '业务线',
                    dataIndex: 'businessLineName'
                },
                /*{
                  title: '物料编号',
                  dataIndex: 'itemNum'
                },
                {
                  title: '物料名称',
                  dataIndex: 'itemDesc'
                },*/
                {
                    title: '发货日期',
                    dataIndex: 'confimDate'
                },
                /*{
                  title: '订单编号',
                  dataIndex: 'orderNumber'
                },*/
                {
                    title: '发货组织',
                    dataIndex: 'organizationName'
                },
                /*{
                  title: '单位',
                  dataIndex: 'unit'
                },
                {
                  title: '订购数量',
                  dataIndex: 'orderSum'
                },
                {
                  title: '已发货数量',
                  dataIndex: 'quantity'
                },
                {
                  title: '未接受数量',
                  dataIndex: 'unquantity'
                },*/
                {
                    title: '子库存',
                    dataIndex: 'substoreName'
                },
                // {
                //   title: '操作',
                //   dataIndex: 'action',

                // }
            ],
            rows,
            //暂时隐藏
            // rowSelection: {
            //   selectedRowKeys,
            //   onChange: self.onSelectChange
            // }
        };

        return <div>
            <DmsTab options={opts} defaultKey={key}><label style={{color: '#ff0520'}}>未显示的出库单，请点击同步按钮</label><Button
                icon="reload"
                onClick={this.sync.bind(this)}>同步</Button>
                <Modal
                    visible={syncVisible}
                    title="同步"
                    onOk={this.syncHandleOk}
                    onCancel={this.syncHandleCancel}
                    maskClosable={false}
                    confirmLoading={syncConfirmLoading}
                    width={400}
                >
                    <div><label>出库单号：</label><InputNumber style={{width: 200}} value={this.state.syncDelivery}
                                                          onChange={this.syncChange.bind(this)}></InputNumber>
                    </div>
                </Modal>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                {/*<div className="dms-table-head">
          {
            this.state.showInStorage &&
            <Button style={{ position: 'absolute', bottom: 8, left: 0 }} onClick={this.addRecord.bind(this)}>入库</Button>
          }
        </div>*/}
                <TableView {...tableViewProps} />
            </div>

            <Modal
                visible={visible}
                title="入库"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                confirmLoading={confirmLoading}
                width={800}
            >
                <div>
                    <Row>
                        <Col>
                            <label className="ant-form-item-required">是否增加库存：</label>
                            <Radio.Group onChange={self.isAddStore} value={this.state.isAddStore}>
                                <Radio value={'Y'}>是</Radio>
                                <Radio value={'N'}>否</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 10}}>
                        <Col>
                            <label>子库存：</label>
                            <Select defaultValue="" dropdownMatchSelectWidth={false} style={{width: 120}}
                                    onChange={self.handleChange} allowClear={true}
                                    value={this.state.substorageid}>
                                {
                                    this.state.scInventory.map(this.inventoryOption)
                                }
                            </Select>
                        </Col>
                    </Row>
                    {
                        // <Row style={{marginTop:10}}>
                        //   <Col>
                        //     <label className="ant-form-item-required">验证码：</label>
                        //     <Input style={{width:65}} maxLength={6}/>
                        //     <Button style={{marginLeft:10}}>获取验证码</Button>
                        //     <span style={{fontSize: 'xx-small', display: 'none'}}>已向授权收货人xxasdasdasdasdasdasdasdasdasdasdasdasdasd手机：13888888888发送短信</span>
                        //   </Col>
                        // </Row>
                    }
                </div>
            </Modal>
        </div>
    }
}
;
export default withRouter(ReceivingList);


// WEBPACK FOOTER //
// ./src/routes/receiving/list.js